const borderColor = {
  name: "border-color",
  path: "/border-color",
  title: "border-color",
  description: "Utilities for controlling the color of an element's borders.",
  value: {
  "border-color": {
    "border-color-inherit": "inherit",
    "border-color-current": "currentColor",
    "border-color-transparent": "transparent",
    "border-color-[<value>]": "<value>",
    "border-color-black": "var(--color-black)",
    "border-color-white": "var(--color-white)",
    "border-color-red-50": "var(--color-red-50)",
    "border-color-red-100": "var(--color-red-100)",
    "border-color-red-200": "var(--color-red-200)",
    "border-color-red-300": "var(--color-red-300)",
    "border-color-red-400": "var(--color-red-400)",
    "border-color-red-500": "var(--color-red-500)",
    "border-color-red-600": "var(--color-red-600)",
    "border-color-red-700": "var(--color-red-700)",
    "border-color-red-800": "var(--color-red-800)",
    "border-color-red-900": "var(--color-red-900)",
    "border-color-orange-50": "var(--color-orange-50)",
    "border-color-orange-100": "var(--color-orange-100)",
    "border-color-orange-200": "var(--color-orange-200)",
    "border-color-orange-300": "var(--color-orange-300)",
    "border-color-orange-400": "var(--color-orange-400)",
    "border-color-orange-500": "var(--color-orange-500)",
    "border-color-orange-600": "var(--color-orange-600)",
    "border-color-orange-700": "var(--color-orange-700)",
    "border-color-orange-800": "var(--color-orange-800)",
    "border-color-orange-900": "var(--color-orange-900)",
    "border-color-amber-50": "var(--color-amber-50)",
    "border-color-amber-100": "var(--color-amber-100)",
    "border-color-amber-200": "var(--color-amber-200)",
    "border-color-amber-300": "var(--color-amber-300)",
    "border-color-amber-400": "var(--color-amber-400)",
    "border-color-amber-500": "var(--color-amber-500)",
    "border-color-amber-600": "var(--color-amber-600)",
    "border-color-amber-700": "var(--color-amber-700)",
    "border-color-amber-800": "var(--color-amber-800)",
    "border-color-amber-900": "var(--color-amber-900)",
    "border-color-yellow-50": "var(--color-yellow-50)",
    "border-color-yellow-100": "var(--color-yellow-100)",
    "border-color-yellow-200": "var(--color-yellow-200)",
    "border-color-yellow-300": "var(--color-yellow-300)",
    "border-color-yellow-400": "var(--color-yellow-400)",
    "border-color-yellow-500": "var(--color-yellow-500)",
    "border-color-yellow-600": "var(--color-yellow-600)",
    "border-color-yellow-700": "var(--color-yellow-700)",
    "border-color-yellow-800": "var(--color-yellow-800)",
    "border-color-yellow-900": "var(--color-yellow-900)",
    "border-color-lime-50": "var(--color-lime-50)",
    "border-color-lime-100": "var(--color-lime-100)",
    "border-color-lime-200": "var(--color-lime-200)",
    "border-color-lime-300": "var(--color-lime-300)",
    "border-color-lime-400": "var(--color-lime-400)",
    "border-color-lime-500": "var(--color-lime-500)",
    "border-color-lime-600": "var(--color-lime-600)",
    "border-color-lime-700": "var(--color-lime-700)",
    "border-color-lime-800": "var(--color-lime-800)",
    "border-color-lime-900": "var(--color-lime-900)",
    "border-color-green-50": "var(--color-green-50)",
    "border-color-green-100": "var(--color-green-100)",
    "border-color-green-200": "var(--color-green-200)",
    "border-color-green-300": "var(--color-green-300)",
    "border-color-green-400": "var(--color-green-400)",
    "border-color-green-500": "var(--color-green-500)",
    "border-color-green-600": "var(--color-green-600)",
    "border-color-green-700": "var(--color-green-700)",
    "border-color-green-800": "var(--color-green-800)",
    "border-color-green-900": "var(--color-green-900)",
    "border-color-emerald-50": "var(--color-emerald-50)",
    "border-color-emerald-100": "var(--color-emerald-100)",
    "border-color-emerald-200": "var(--color-emerald-200)",
    "border-color-emerald-300": "var(--color-emerald-300)",
    "border-color-emerald-400": "var(--color-emerald-400)",
    "border-color-emerald-500": "var(--color-emerald-500)",
    "border-color-emerald-600": "var(--color-emerald-600)",
    "border-color-emerald-700": "var(--color-emerald-700)",
    "border-color-emerald-800": "var(--color-emerald-800)",
    "border-color-emerald-900": "var(--color-emerald-900)",
    "border-color-teal-50": "var(--color-teal-50)",
    "border-color-teal-100": "var(--color-teal-100)",
    "border-color-teal-200": "var(--color-teal-200)",
    "border-color-teal-300": "var(--color-teal-300)",
    "border-color-teal-400": "var(--color-teal-400)",
    "border-color-teal-500": "var(--color-teal-500)",
    "border-color-teal-600": "var(--color-teal-600)",
    "border-color-teal-700": "var(--color-teal-700)",
    "border-color-teal-800": "var(--color-teal-800)",
    "border-color-teal-900": "var(--color-teal-900)",
    "border-color-cyan-50": "var(--color-cyan-50)",
    "border-color-cyan-100": "var(--color-cyan-100)",
    "border-color-cyan-200": "var(--color-cyan-200)",
    "border-color-cyan-300": "var(--color-cyan-300)",
    "border-color-cyan-400": "var(--color-cyan-400)",
    "border-color-cyan-500": "var(--color-cyan-500)",
    "border-color-cyan-600": "var(--color-cyan-600)",
    "border-color-cyan-700": "var(--color-cyan-700)",
    "border-color-cyan-800": "var(--color-cyan-800)",
    "border-color-cyan-900": "var(--color-cyan-900)",
    "border-color-sky-50": "var(--color-sky-50)",
    "border-color-sky-100": "var(--color-sky-100)",
    "border-color-sky-200": "var(--color-sky-200)",
    "border-color-sky-300": "var(--color-sky-300)",
    "border-color-sky-400": "var(--color-sky-400)",
    "border-color-sky-500": "var(--color-sky-500)",
    "border-color-sky-600": "var(--color-sky-600)",
    "border-color-sky-700": "var(--color-sky-700)",
    "border-color-sky-800": "var(--color-sky-800)",
    "border-color-sky-900": "var(--color-sky-900)",
    "border-color-blue-50": "var(--color-blue-50)",
    "border-color-blue-100": "var(--color-blue-100)",
    "border-color-blue-200": "var(--color-blue-200)",
    "border-color-blue-300": "var(--color-blue-300)",
    "border-color-blue-400": "var(--color-blue-400)",
    "border-color-blue-500": "var(--color-blue-500)",
    "border-color-blue-600": "var(--color-blue-600)",
    "border-color-blue-700": "var(--color-blue-700)",
    "border-color-blue-800": "var(--color-blue-800)",
    "border-color-blue-900": "var(--color-blue-900)",
    "border-color-indigo-50": "var(--color-indigo-50)",
    "border-color-indigo-100": "var(--color-indigo-100)",
    "border-color-indigo-200": "var(--color-indigo-200)",
    "border-color-indigo-300": "var(--color-indigo-300)",
    "border-color-indigo-400": "var(--color-indigo-400)",
    "border-color-indigo-500": "var(--color-indigo-500)",
    "border-color-indigo-600": "var(--color-indigo-600)",
    "border-color-indigo-700": "var(--color-indigo-700)",
    "border-color-indigo-800": "var(--color-indigo-800)",
    "border-color-indigo-900": "var(--color-indigo-900)",
    "border-color-violet-50": "var(--color-violet-50)",
    "border-color-violet-100": "var(--color-violet-100)",
    "border-color-violet-200": "var(--color-violet-200)",
    "border-color-violet-300": "var(--color-violet-300)",
    "border-color-violet-400": "var(--color-violet-400)",
    "border-color-violet-500": "var(--color-violet-500)",
    "border-color-violet-600": "var(--color-violet-600)",
    "border-color-violet-700": "var(--color-violet-700)",
    "border-color-violet-800": "var(--color-violet-800)",
    "border-color-violet-900": "var(--color-violet-900)",
    "border-color-purple-50": "var(--color-purple-50)",
    "border-color-purple-100": "var(--color-purple-100)",
    "border-color-purple-200": "var(--color-purple-200)",
    "border-color-purple-300": "var(--color-purple-300)",
    "border-color-purple-400": "var(--color-purple-400)",
    "border-color-purple-500": "var(--color-purple-500)",
    "border-color-purple-600": "var(--color-purple-600)",
    "border-color-purple-700": "var(--color-purple-700)",
    "border-color-purple-800": "var(--color-purple-800)",
    "border-color-purple-900": "var(--color-purple-900)",
    "border-color-fuchsia-50": "var(--color-fuchsia-50)",
    "border-color-fuchsia-100": "var(--color-fuchsia-100)",
    "border-color-fuchsia-200": "var(--color-fuchsia-200)",
    "border-color-fuchsia-300": "var(--color-fuchsia-300)",
    "border-color-fuchsia-400": "var(--color-fuchsia-400)",
    "border-color-fuchsia-500": "var(--color-fuchsia-500)",
    "border-color-fuchsia-600": "var(--color-fuchsia-600)",
    "border-color-fuchsia-700": "var(--color-fuchsia-700)",
    "border-color-fuchsia-800": "var(--color-fuchsia-800)",
    "border-color-fuchsia-900": "var(--color-fuchsia-900)",
    "border-color-pink-50": "var(--color-pink-50)",
    "border-color-pink-100": "var(--color-pink-100)",
    "border-color-pink-200": "var(--color-pink-200)",
    "border-color-pink-300": "var(--color-pink-300)",
    "border-color-pink-400": "var(--color-pink-400)",
    "border-color-pink-500": "var(--color-pink-500)",
    "border-color-pink-600": "var(--color-pink-600)",
    "border-color-pink-700": "var(--color-pink-700)",
    "border-color-pink-800": "var(--color-pink-800)",
    "border-color-pink-900": "var(--color-pink-900)",
    "border-color-rose-50": "var(--color-rose-50)",
    "border-color-rose-100": "var(--color-rose-100)",
    "border-color-rose-200": "var(--color-rose-200)",
    "border-color-rose-300": "var(--color-rose-300)",
    "border-color-rose-400": "var(--color-rose-400)",
    "border-color-rose-500": "var(--color-rose-500)",
    "border-color-rose-600": "var(--color-rose-600)",
    "border-color-rose-700": "var(--color-rose-700)",
    "border-color-rose-800": "var(--color-rose-800)",
    "border-color-rose-900": "var(--color-rose-900)",
    "border-color-slate-50": "var(--color-slate-50)",
    "border-color-slate-100": "var(--color-slate-100)",
    "border-color-slate-200": "var(--color-slate-200)",
    "border-color-slate-300": "var(--color-slate-300)",
    "border-color-slate-400": "var(--color-slate-400)",
    "border-color-slate-500": "var(--color-slate-500)",
    "border-color-slate-600": "var(--color-slate-600)",
    "border-color-slate-700": "var(--color-slate-700)",
    "border-color-slate-800": "var(--color-slate-800)",
    "border-color-slate-900": "var(--color-slate-900)",
    "border-color-gray-50": "var(--color-gray-50)",
    "border-color-gray-100": "var(--color-gray-100)",
    "border-color-gray-200": "var(--color-gray-200)",
    "border-color-gray-300": "var(--color-gray-300)",
    "border-color-gray-400": "var(--color-gray-400)",
    "border-color-gray-500": "var(--color-gray-500)",
    "border-color-gray-600": "var(--color-gray-600)",
    "border-color-gray-700": "var(--color-gray-700)",
    "border-color-gray-800": "var(--color-gray-800)",
    "border-color-gray-900": "var(--color-gray-900)",
    "border-color-zinc-50": "var(--color-zinc-50)",
    "border-color-zinc-100": "var(--color-zinc-100)",
    "border-color-zinc-200": "var(--color-zinc-200)",
    "border-color-zinc-300": "var(--color-zinc-300)",
    "border-color-zinc-400": "var(--color-zinc-400)",
    "border-color-zinc-500": "var(--color-zinc-500)",
    "border-color-zinc-600": "var(--color-zinc-600)",
    "border-color-zinc-700": "var(--color-zinc-700)",
    "border-color-zinc-800": "var(--color-zinc-800)",
    "border-color-zinc-900": "var(--color-zinc-900)",
    "border-color-neutral-50": "var(--color-neutral-50)",
    "border-color-neutral-100": "var(--color-neutral-100)",
    "border-color-neutral-200": "var(--color-neutral-200)",
    "border-color-neutral-300": "var(--color-neutral-300)",
    "border-color-neutral-400": "var(--color-neutral-400)",
    "border-color-neutral-500": "var(--color-neutral-500)",
    "border-color-neutral-600": "var(--color-neutral-600)",
    "border-color-neutral-700": "var(--color-neutral-700)",
    "border-color-neutral-800": "var(--color-neutral-800)",
    "border-color-neutral-900": "var(--color-neutral-900)",
    "border-color-stone-50": "var(--color-stone-50)",
    "border-color-stone-100": "var(--color-stone-100)",
    "border-color-stone-200": "var(--color-stone-200)",
    "border-color-stone-300": "var(--color-stone-300)",
    "border-color-stone-400": "var(--color-stone-400)",
    "border-color-stone-500": "var(--color-stone-500)",
    "border-color-stone-600": "var(--color-stone-600)",
    "border-color-stone-700": "var(--color-stone-700)",
    "border-color-stone-800": "var(--color-stone-800)",
    "border-color-stone-900": "var(--color-stone-900)"
  }
},
  exampleData: [
    {
      example: {
        code: `<div class="border-4 border-color-indigo-500 ...">border-color-indigo-500</div>
<div class="border-4 border-color-purple-500 ... border-2">border-color-purple-500</div>
<div class="border-4 border-color-sky-500 ... border-4">border-color-sky-500</div>
<div class="border-4 border-color-[#f44336] ... border-4">border-color-[#f44336]</div>`
      }
    },
    {
      example: {
        code: `<div class="border-4 border-indigo-500/100 ..."></div>
<div class="border-4 border-indigo-500/75 ..."></div>
<div class="border-4 border-indigo-500/50 ..."></div>`
      }
    },
    {
      example: {
        code: `<div class="border-4 border-color-indigo-200 border-t-color-indigo-500 ..."></div>
<div class="border-4 border-color-indigo-200 border-r-color-indigo-500 ..."></div>
<div class="border-4 border-color-indigo-200 border-b-color-indigo-500 ..."></div>
<div class="border-4 border-color-indigo-200 border-l-color-[#ffc107] ..."></div>`
      }
    },
    {
      example: {
        code: `<div class="border-4 border-color-indigo-200 border-x-color-indigo-500 ..."></div>
<div class="border-4 border-indigo-color-200 border-y-color-[#ffc107] ..."></div>`
      }
    },
    {
      example: {
        code: `<div class="grid grid-columns-3 divide-x-4 divide-color-blue-500">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>

<div class="flex flex-col divide-y-4 divide-color-[#ffc107]">
  <div>01</div>
  <div>02</div>
  <div>03</div>
</div>`
      }
    },
  ],
  htmlData: [
   {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">border-color-indigo-500</code>, and
        <code class="text-color-gray-800 dark:text-color-white font-semibold">border-color-lime-100</code>
        to control the border color of an element:
      </p>
      <div class="flex justify-center gap-6 items-center  font-mono text-sm font-bold flex-wrap text-color-gray-500">
          <div class="border-4 border-color-indigo-500 flex justify-center items-center p-4 h-20">border-color-indigo-500</div>
          <div class="border-4 border-color-purple-500 flex justify-center items-center p-4 h-20 border-2">border-color-purple-500</div>
          <div class="border-4 border-color-sky-500 flex justify-center items-center p-4 h-20 border-4">border-color-sky-500</div>
          <div class="border-4 border-color-[#f44336] flex justify-center items-center p-4 h-20 border-4">border-color-[#f44336]</div>
      </div>
      `
    },
   {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">Changing the opacity</code>
        Use the color opacity modifier to control the opacity of an element's border color:
      </p>
      <div class="flex justify-center gap-6 items-center  font-mono text-sm font-bold flex-wrap text-color-gray-500">
          <div class="border-4 border-color-indigo-500/90 flex justify-center items-center p-4 h-20">border-color-indigo-500/90</div>
          <div class="border-4 border-color-indigo-500/50 flex justify-center items-center p-4 h-20">border-color-indigo-500/50</div>
          <div class="border-4 border-color-indigo-500/25 flex justify-center items-center p-4 h-20">border-color-indigo-500/25</div>
      </div>
      `
    },
   {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">border-t-color-indigo-500</code>, and
        <code class="text-color-gray-800 dark:text-color-white font-semibold">border-r-color-lime-100</code>
        to set the border color for one side of an element:
      </p>
      <div class="flex   justify-center gap-6 items-center  font-mono text-sm font-bold flex-wrap text-color-gray-500">
          <div class="border-4  border-color-indigo-200 border-t-color-indigo-500 flex justify-center items-center p-4 h-20">border-t-color-indigo-500</div>
          <div class="border-4  border-color-indigo-200 border-r-color-indigo-500  flex justify-center items-center p-4 h-20 border-2">border-r-color-indigo-500</div>
          <div class="border-4  border-color-indigo-200 border-b-color-indigo-500 flex justify-center items-center p-4 h-20 border-4">border-b-color-indigo-500</div>
          <div class="border-4  border-color-indigo-200 border-l-color-[#ffc107] flex justify-center items-center p-4 h-20 border-4">border-l-color-[#ffc107]</div>
      </div>
      `
    },
   {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">border-x-color-indigo-500</code>, and
        <code class="text-color-gray-800 dark:text-color-white font-semibold">border-y-color-lime-100</code>
        to set the border color for one side of an element:
      </p>
      <div class="flex   justify-center gap-6 items-center  font-mono text-sm font-bold flex-wrap text-color-gray-500">
          <div class="border-4  border-color-indigo-200 border-x-color-indigo-500 flex justify-center items-center p-4 h-20">border-x-color-indigo-500</div>
          <div class="border-4  border-color-indigo-200 border-y-color-[#ffc107]   flex justify-center items-center p-4 h-20 border-2">border-y-color-[#ffc107] </div>      </div>
      `
    },
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">divide-indigo-500</code>, and <code class="text-color-gray-800 dark:text-color-white font-semibold">divide-lime-100</code>
        to add borders between child elements:
      </p>
      <div class="grid grid-columns-3 divide-x-4 divide-color-blue-500 *:flex *:justify-center *:items-center *:p-4">
        <div class="outline outline-style-dashed outline-color-gray-300 dark:outline-color-gray-500">01</div>
        <div class="outline outline-style-dashed outline-color-gray-300 dark:outline-color-gray-500">02</div>
        <div class="outline outline-style-dashed outline-color-gray-300 dark:outline-color-gray-500">03</div>
      </div>

      <div class="flex flex-col mt-10 divide-y-4 divide-color-[#ffc107] *:flex *:justify-center *:items-center *:p-4">
        <div class="outline outline-style-dashed outline-color-gray-300 dark:outline-color-gray-500">01</div>
        <div class="outline outline-style-dashed outline-color-gray-300 dark:outline-color-gray-500">02</div>
        <div class="outline outline-style-dashed outline-color-gray-300 dark:outline-color-gray-500">03</div>
      </div>
      `
    },
]
}
export default borderColor;

<div class="sr-only">
          <div class="border-4 border-color-indigo-200 divide-color-[#ffc107] border-x-color-indigo-500  border-y-color-[#ffc107]  border-l-color-[#ffc107]   border-t-color-indigo-500 border-r-color-indigo-500 border-b-color-indigo-500 border-l-color-indigo-500 border-color-indigo-500 border-color-indigo-500/90 border-color-indigo-500/50 border-color-indigo-500/25 flex justify-center items-center p-4 h-20">border-color-indigo-500</div>
          <div class="border-4 border-color-purple-500 flex justify-center items-center p-4 h-20 border-2">border-color-purple-500</div>
          <div class="border-4 border-color-sky-500 flex justify-center items-center p-4 h-20 border-4">border-color-sky-500</div>
          <div class="border-4 border-color-[#f44336] flex justify-center items-center p-4 h-20 border-4">border-color-[#f44336]</div>

</div>